"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireWildcard(require("react"));

var _reactSpring = require("react-spring");

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _hooks = require("../hooks");

var _layout = require("../layout");

var _propTypes = require("../prop-types");

var _constants = require("./constants");

var _core = require("@emotion/core");

var HideableDiv = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1vjef4v0"
})(function (_ref) {
  var isVisible = _ref.isVisible;
  return {
    display: 'flex',
    flexDirection: 'column',
    visibility: isVisible ? 'visible' : 'hidden'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2V4cGFuZGVyL0V4cGFuZGVyQ29udGVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBaUJvQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvc3VibW9kdWxlcy9leHBhbmRlci9FeHBhbmRlckNvbnRlbnQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IHVzZVN0YXRlLCB1c2VFZmZlY3QgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyB1c2VTcHJpbmcsIGFuaW1hdGVkIH0gZnJvbSAncmVhY3Qtc3ByaW5nJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgZGVzY3JpYmUsIFByb3BUeXBlcyB9IGZyb20gJ0BhbXpuL3N0ZW5jaWwtcmVhY3QtZGVzYyc7XG5cbmltcG9ydCB7IHVzZVJlc2l6ZU9ic2VydmVyIH0gZnJvbSAnLi4vaG9va3MnO1xuaW1wb3J0IHsgU3BhY2VyIH0gZnJvbSAnLi4vbGF5b3V0JztcbmltcG9ydCB7IGNzc1ZhbHVlIH0gZnJvbSAnLi4vcHJvcC10eXBlcyc7XG5cbmltcG9ydCB7IEV4cGFuZGVyQ29udGVudFByb3BzIH0gZnJvbSAnLi9pbnRlcmZhY2VzJztcbmltcG9ydCB7IEV4cGFuZGVyQ29udGVudERlZmF1bHRQcm9wcyBhcyBkZWZhdWx0UHJvcHMgfSBmcm9tICcuL2NvbnN0YW50cyc7XG5cbmludGVyZmFjZSBIaWRlYWJsZURpdlByb3BzIHtcbiAgaXNWaXNpYmxlOiBib29sZWFuO1xufVxuXG5jb25zdCBIaWRlYWJsZURpdiA9IHN0eWxlZCgnZGl2Jyk8SGlkZWFibGVEaXZQcm9wcz4oKHsgaXNWaXNpYmxlIH0pID0+ICh7XG4gIGRpc3BsYXk6ICdmbGV4JyxcbiAgZmxleERpcmVjdGlvbjogJ2NvbHVtbicsXG4gIHZpc2liaWxpdHk6IGlzVmlzaWJsZSA/ICd2aXNpYmxlJyA6ICdoaWRkZW4nXG59KSk7XG5cbmNvbnN0IEV4cGFuZGVyQ29udGVudFdpdGhvdXREb2NzOiBSZWFjdC5GQzxFeHBhbmRlckNvbnRlbnRQcm9wcz4gPSAoe1xuICBjaGlsZHJlbixcbiAgaXNFeHBhbmRlZCA9IGRlZmF1bHRQcm9wcy5pc0V4cGFuZGVkLFxuICB0b3BTcGFjaW5nID0gZGVmYXVsdFByb3BzLnRvcFNwYWNpbmcsXG4gIGlkLFxuICBzaG91bGRBbmltYXRlSW1tZWRpYXRlbHkgPSBkZWZhdWx0UHJvcHMuc2hvdWxkQW5pbWF0ZUltbWVkaWF0ZWx5LFxuICBkYXRhVGVzdElkXG59KSA9PiB7XG4gIGNvbnN0IFtpc1Zpc2libGUsIHNldFZpc2libGVdID0gdXNlU3RhdGUoaXNFeHBhbmRlZCk7XG4gIGNvbnN0IFtpc0Z1bGx5RXhwYW5kZWQsIHNldEZ1bGx5RXhwYW5kZWRdID0gdXNlU3RhdGUoaXNFeHBhbmRlZCk7XG5cbiAgY29uc3QgeyByZWYsIGhlaWdodDogY29udGVudEhlaWdodCB9ID0gdXNlUmVzaXplT2JzZXJ2ZXI8SFRNTERpdkVsZW1lbnQ+KHtcbiAgICAvLyBJZiBjb250ZW50SGVpZ2h0IGlzbid0IGNhbGN1bGF0ZWQgeWV0LCB1c2UgYW4gZXh0cmVtZWx5IGxhcmdlIG1heEhlaWdodCB0b1xuICAgIC8vIHByZXZlbnQgY29udGVudCBzaGlmdGluZyBhcm91bmQgb25jZSBpdCBoYXMgYmVlbiBjYWxjdWxhdGVkLiBUaGUgY2hhbmdlXG4gICAgLy8gd29uJ3QgYmUgdmlzaWJsZSBiZWNhdXNlIHRoaXMgaXMgbWF4SGVpZ2h0IG5vdCBoZWlnaHQsIHNvIHRoZSBleHBhbmRlciB3b24ndFxuICAgIC8vIGdyb3cgYmlnZ2VyIHRoYW4gdGhlIGNvbnRlbnQgYW55d2F5LlxuICAgIGRlZmF1bHRIZWlnaHQ6IDk5OTk5XG4gIH0pO1xuXG4gIGNvbnN0IGNvbGxhcHNlZFN0eWxlcyA9IHtcbiAgICBvcGFjaXR5OiAwLFxuICAgIG1heEhlaWdodDogMFxuICB9O1xuICBjb25zdCBleHBhbmRlZFN0eWxlcyA9IHtcbiAgICBvcGFjaXR5OiAxLFxuICAgIG1heEhlaWdodDogY29udGVudEhlaWdodFxuICB9O1xuXG4gIGNvbnN0IHN0eWxlcyA9IGlzRXhwYW5kZWQgPyBleHBhbmRlZFN0eWxlcyA6IGNvbGxhcHNlZFN0eWxlcztcblxuICBjb25zdCBbcHJvcHMsIHNldFNwcmluZ1Byb3BzXSA9IHVzZVNwcmluZygoKSA9PiAoe1xuICAgIC4uLnN0eWxlc1xuICB9KSk7XG5cbiAgdXNlRWZmZWN0KCgpID0+IHtcbiAgICBpZiAoaXNFeHBhbmRlZCkge1xuICAgICAgLy8gTWFrZSBjb250ZW50IHZpc2libGUgYmVmb3JlIHN0YXJ0aW5nIHRoZSBhbmltYXRpb24sIGFuZCBkbyBub3RoaW5nIGFmdGVyXG4gICAgICAvLyB0aGUgYW5pbWF0aW9uIGVuZHMgKG9uUmVzdCBoYXMgdG8gYmUgZXhwbGljaXRseSBzZXQgYmVjYXVzZSBpdCB3aWxsIGJlXG4gICAgICAvLyBjYWNoZWQgd2l0aCB0aGUgdmFsdWUgYmVsb3cpXG4gICAgICBzZXRWaXNpYmxlKHRydWUpO1xuICAgICAgc2V0U3ByaW5nUHJvcHMoe1xuICAgICAgICAuLi5leHBhbmRlZFN0eWxlcyxcbiAgICAgICAgb25SZXN0OiAoKSA9PiB7XG4gICAgICAgICAgc2V0RnVsbHlFeHBhbmRlZCh0cnVlKTtcbiAgICAgICAgfVxuICAgICAgfSk7XG4gICAgfSBlbHNlIHtcbiAgICAgIHNldEZ1bGx5RXhwYW5kZWQoZmFsc2UpO1xuICAgICAgLy8gTWFrZSB0aGUgY29udGVudCBpbnZpc2libGUgYWZ0ZXIgdGhlIGFuaW1hdGlvbiBlbmRzXG4gICAgICBzZXRTcHJpbmdQcm9wcyh7XG4gICAgICAgIC4uLmNvbGxhcHNlZFN0eWxlcyxcbiAgICAgICAgaW1tZWRpYXRlOiBzaG91bGRBbmltYXRlSW1tZWRpYXRlbHksXG4gICAgICAgIG9uUmVzdDogKCkgPT4gc2V0VmlzaWJsZShmYWxzZSlcbiAgICAgIH0pO1xuICAgIH1cbiAgfSwgW1xuICAgIGlzRXhwYW5kZWQsXG4gICAgZXhwYW5kZWRTdHlsZXMsXG4gICAgY29sbGFwc2VkU3R5bGVzLFxuICAgIHNldFZpc2libGUsXG4gICAgc2hvdWxkQW5pbWF0ZUltbWVkaWF0ZWx5XG4gIF0pO1xuXG4gIHJldHVybiAoXG4gICAgPGFuaW1hdGVkLmRpdlxuICAgICAgc3R5bGU9e3tcbiAgICAgICAgLi4ucHJvcHMsXG4gICAgICAgIG92ZXJmbG93OiBpc0Z1bGx5RXhwYW5kZWQgPyAndmlzaWJsZScgOiAnaGlkZGVuJ1xuICAgICAgfX1cbiAgICAgIGRhdGEtdGVzdC1jb21wb25lbnQ9XCJTdGVuY2lsRXhwYW5kZXJDb250ZW50XCJcbiAgICAgIGRhdGEtdGVzdC1pZD17ZGF0YVRlc3RJZH0+XG4gICAgICA8SGlkZWFibGVEaXZcbiAgICAgICAgaWQ9e2lkfVxuICAgICAgICByZWY9e3JlZn1cbiAgICAgICAgaXNWaXNpYmxlPXtpc1Zpc2libGV9XG4gICAgICAgIGFyaWEtaGlkZGVuPXshaXNWaXNpYmxlfT5cbiAgICAgICAgPFNwYWNlciBoZWlnaHQ9e3RvcFNwYWNpbmd9IC8+XG4gICAgICAgIHtjaGlsZHJlbn1cbiAgICAgIDwvSGlkZWFibGVEaXY+XG4gICAgPC9hbmltYXRlZC5kaXY+XG4gICk7XG59O1xuXG5FeHBhbmRlckNvbnRlbnRXaXRob3V0RG9jcy5kZWZhdWx0UHJvcHMgPSB7IC4uLmRlZmF1bHRQcm9wcyB9O1xuXG5jb25zdCBFeHBhbmRlckNvbnRlbnQgPSBkZXNjcmliZShFeHBhbmRlckNvbnRlbnRXaXRob3V0RG9jcykuZGVzY3JpcHRpb24oXG4gICdDb250YWluZXIgd2hpY2ggY2FuIGJlIGNvbGxhcHNlZCBvciBleHBhbmRlZC4nXG4pO1xuXG5FeHBhbmRlckNvbnRlbnQucHJvcFR5cGVzID0ge1xuICBjaGlsZHJlbjogUHJvcFR5cGVzLm5vZGUuZGVzY3JpcHRpb24oJ0NvbnRlbnQgdG8gZGlzcGxheSBpbiB0aGUgY29udGFpbmVyLicpLFxuICBpZDogUHJvcFR5cGVzLnN0cmluZy5kZXNjcmlwdGlvbihcbiAgICBcIlNldHMgdGhlICdpZCcgYXR0cmlidXRlIGluIHRoZSBET00gZm9yIHRoZSBjb250ZW50LlwiXG4gICksXG4gIGlzRXhwYW5kZWQ6IFByb3BUeXBlcy5ib29sXG4gICAgLmRlc2NyaXB0aW9uKFxuICAgICAgJ1doZXRoZXIgdGhlIGNvbnRhaW5lciBzaG91bGQgYmUgZXhwYW5kZWQuIElmIGZhbHNlLCB0aGUgY29udGVudCB3aWxsIG5vdCBiZSB2aXNpYmxlLidcbiAgICApXG4gICAgLy8gTm9ybWFsbHkgZGVmYXVsdHMgd291bGQgY29tZSBmcm9tIGRlZmF1bHRQcm9wcyBhdXRvbWF0aWNhbGx5IGJ1dCBkdWUgdG8gYVxuICAgIC8vIGJ1ZyBpbiByZWFjdC1kZXNjLCBkZWZhdWx0cyB0aGF0IGFyZSBmYWxzeSBnZXQgaWdub3JlZC5cbiAgICAuZGVmYXVsdFZhbHVlKGRlZmF1bHRQcm9wcy5pc0V4cGFuZGVkKSxcbiAgdG9wU3BhY2luZzogY3NzVmFsdWUoKVxuICAgIC5kZXNjcmlwdGlvbihcbiAgICAgICdTcGFjaW5nIGluIHBpeGVscyB0byBhZGQgYWJvdmUgdGhlIGNvbnRlbnQgYXQgdGhlIHRvcCBvZiB0aGUgY29udGFpbmVyLidcbiAgICApXG4gICAgLy8gU2FtZSBhcyBhYm92ZVxuICAgIC5kZWZhdWx0VmFsdWUoZGVmYXVsdFByb3BzLnRvcFNwYWNpbmcpLFxuICBkYXRhVGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLmRlc2NyaXB0aW9uKFxuICAgIFwiU2V0cyB0aGUgJ2RhdGEtdGVzdC1pZCcgYXR0cmlidXRlIGluIHRoZSBET00sIGZvciB0ZXN0aW5nIHB1cnBvc2VzLlwiXG4gIClcbn07XG5cbkV4cGFuZGVyQ29udGVudC5kaXNwbGF5TmFtZSA9ICdFeHBhbmRlckNvbnRlbnQnO1xuXG5leHBvcnQgZGVmYXVsdCBFeHBhbmRlckNvbnRlbnQ7XG4iXX0= */");

var ExpanderContentWithoutDocs = function ExpanderContentWithoutDocs(_ref2) {
  var children = _ref2.children,
      _ref2$isExpanded = _ref2.isExpanded,
      isExpanded = _ref2$isExpanded === void 0 ? _constants.ExpanderContentDefaultProps.isExpanded : _ref2$isExpanded,
      _ref2$topSpacing = _ref2.topSpacing,
      topSpacing = _ref2$topSpacing === void 0 ? _constants.ExpanderContentDefaultProps.topSpacing : _ref2$topSpacing,
      id = _ref2.id,
      _ref2$shouldAnimateIm = _ref2.shouldAnimateImmediately,
      shouldAnimateImmediately = _ref2$shouldAnimateIm === void 0 ? _constants.ExpanderContentDefaultProps.shouldAnimateImmediately : _ref2$shouldAnimateIm,
      dataTestId = _ref2.dataTestId;

  var _useState = (0, _react.useState)(isExpanded),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isVisible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react.useState)(isExpanded),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isFullyExpanded = _useState4[0],
      setFullyExpanded = _useState4[1];

  var _useResizeObserver = (0, _hooks.useResizeObserver)({
    // If contentHeight isn't calculated yet, use an extremely large maxHeight to
    // prevent content shifting around once it has been calculated. The change
    // won't be visible because this is maxHeight not height, so the expander won't
    // grow bigger than the content anyway.
    defaultHeight: 99999
  }),
      ref = _useResizeObserver.ref,
      contentHeight = _useResizeObserver.height;

  var collapsedStyles = {
    opacity: 0,
    maxHeight: 0
  };
  var expandedStyles = {
    opacity: 1,
    maxHeight: contentHeight
  };
  var styles = isExpanded ? expandedStyles : collapsedStyles;

  var _useSpring = (0, _reactSpring.useSpring)(function () {
    return (0, _objectSpread2.default)({}, styles);
  }),
      _useSpring2 = (0, _slicedToArray2.default)(_useSpring, 2),
      props = _useSpring2[0],
      setSpringProps = _useSpring2[1];

  (0, _react.useEffect)(function () {
    if (isExpanded) {
      // Make content visible before starting the animation, and do nothing after
      // the animation ends (onRest has to be explicitly set because it will be
      // cached with the value below)
      setVisible(true);
      setSpringProps((0, _objectSpread2.default)({}, expandedStyles, {
        onRest: function onRest() {
          setFullyExpanded(true);
        }
      }));
    } else {
      setFullyExpanded(false); // Make the content invisible after the animation ends

      setSpringProps((0, _objectSpread2.default)({}, collapsedStyles, {
        immediate: shouldAnimateImmediately,
        onRest: function onRest() {
          return setVisible(false);
        }
      }));
    }
  }, [isExpanded, expandedStyles, collapsedStyles, setVisible, shouldAnimateImmediately]);
  return (0, _core.jsx)(_reactSpring.animated.div, {
    style: (0, _objectSpread2.default)({}, props, {
      overflow: isFullyExpanded ? 'visible' : 'hidden'
    }),
    "data-test-component": "StencilExpanderContent",
    "data-test-id": dataTestId
  }, (0, _core.jsx)(HideableDiv, {
    id: id,
    ref: ref,
    isVisible: isVisible,
    "aria-hidden": !isVisible
  }, (0, _core.jsx)(_layout.Spacer, {
    height: topSpacing
  }), children));
};

ExpanderContentWithoutDocs.defaultProps = (0, _objectSpread2.default)({}, _constants.ExpanderContentDefaultProps);
var ExpanderContent = (0, _stencilReactDesc.describe)(ExpanderContentWithoutDocs).description('Container which can be collapsed or expanded.');
ExpanderContent.propTypes = {
  children: _stencilReactDesc.PropTypes.node.description('Content to display in the container.'),
  id: _stencilReactDesc.PropTypes.string.description("Sets the 'id' attribute in the DOM for the content."),
  isExpanded: _stencilReactDesc.PropTypes.bool.description('Whether the container should be expanded. If false, the content will not be visible.') // Normally defaults would come from defaultProps automatically but due to a
  // bug in react-desc, defaults that are falsy get ignored.
  .defaultValue(_constants.ExpanderContentDefaultProps.isExpanded),
  topSpacing: (0, _propTypes.cssValue)().description('Spacing in pixels to add above the content at the top of the container.') // Same as above
  .defaultValue(_constants.ExpanderContentDefaultProps.topSpacing),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
};
ExpanderContent.displayName = 'ExpanderContent';
var _default = ExpanderContent;
exports.default = _default;